// @flow

import { useContext } from 'react';

import { useTranslator } from '@gandi/translate';
import { Fqdn } from '@gandi/ui';

import { ListRow } from '../../ListRow';
import { ProductContext } from '../modules/ProductContext';

import ProductItem from './components/ProductItem';

export function PremiumDNSRenew(): React.MixedElement {
  const product = useContext(ProductContext);
  const { fqdn } = product;
  const { __ } = useTranslator();

  const duration = product.prices?.[0]?.duration;
  const details = [
    <Fqdn>{__('for %(fqdn)s', { fqdn: fqdn || '' })}</Fqdn>,
    !!duration && duration >= 12
      ? __('Will be renewed for %(count)s years', {
          count: duration / 12,
        })
      : __('Will be renewed for %(count)s months', { count: duration }),
  ];

  return (
    <ProductItem
      label={__('Pack DNS Security+')}
      productId={product.id}
      priceBeforeTaxes={product.total?.before_taxes}
      hasTaxes={product.hasTaxes}
      listRow={<ListRow intent="muted" options={details} />}
    />
  );
}
